import * as reactiveUtils from "@arcgis/core/core/reactiveUtils";
import getActiveFieldsFromPopupTemplate from "../../utility-tools/getActiveFieldsFromPopupTemplate"

export const selectLayerWatchLength = (
  view,
  graphicLayer,
  setState,
  callback = (e) => setStateWithTableObjectArray(view,graphicLayer, setState, e)
) => {
  reactiveUtils.watch(
    () => {
      return graphicLayer.graphics.length;
    },
    (e) => {
      callback(e);
    }
  );
};

const setStateWithTableObjectArray = (view,graphicLayer, setState, e?) => {
  let payload = [];
  const titleList = {};
  graphicLayer.graphics.forEach((graphic) => {
    let graph = graphic as any;
    if (!titleList[graph.parentLayerId]) {
      titleList[graph.parentLayerId] = graph.parentLayerId;
      let lyrList = view.map.allLayers.filter((layer) => {
        return (
          layer.id === graph.parentLayerId && layer.type === "feature"
        );
      });
      if (lyrList.length) {
        let lyr = lyrList.getItemAt(0) as any;
        payload.push({
          layerName: lyr.title,
          layerId:lyr.id,
          fields: lyr.fields,
          features: [graphic],
          geometryType: lyr.geometryType,
          popupFields:getActiveFieldsFromPopupTemplate(lyr.fields,graphic.popupTemplate)
        });
      }
    } else {
      if (payload.length) {
        let payloadFilter = payload.filter(
          (obj) => obj.layerId === graph.parentLayerId
        );
        if (payloadFilter.length) {
          payloadFilter[0].features.push(graphic);
        }
      }
    }
  });
  setState(payload);
};
